/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AuthPopupCallbackRouteImport } from './routes/auth-popup-callback'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as EditorProjectIdRouteImport } from './routes/editor/$projectId'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPopupCallbackRoute = AuthPopupCallbackRouteImport.update({
  id: '/auth-popup-callback',
  path: '/auth-popup-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorProjectIdRoute = EditorProjectIdRouteImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/editor/$projectId.lazy').then((d) => d.Route),
)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth-popup-callback': typeof AuthPopupCallbackRoute
  '/settings': typeof SettingsRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/blog': typeof BlogIndexRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-popup-callback': typeof AuthPopupCallbackRoute
  '/settings': typeof SettingsRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/blog': typeof BlogIndexRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth-popup-callback': typeof AuthPopupCallbackRoute
  '/settings': typeof SettingsRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/blog/': typeof BlogIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-popup-callback'
    | '/settings'
    | '/blog/$slug'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/blog'
    | '/projects'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-popup-callback'
    | '/settings'
    | '/blog/$slug'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/blog'
    | '/projects'
  id:
    | '__root__'
    | '/'
    | '/auth-popup-callback'
    | '/settings'
    | '/blog/$slug'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/blog/'
    | '/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthPopupCallbackRoute: typeof AuthPopupCallbackRoute
  SettingsRoute: typeof SettingsRoute
  BlogSlugRoute: typeof BlogSlugRoute
  EditorProjectIdRoute: typeof EditorProjectIdRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  BlogIndexRoute: typeof BlogIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-popup-callback': {
      id: '/auth-popup-callback'
      path: '/auth-popup-callback'
      fullPath: '/auth-popup-callback'
      preLoaderRoute: typeof AuthPopupCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/$projectId': {
      id: '/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/editor/$projectId'
      preLoaderRoute: typeof EditorProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthPopupCallbackRoute: AuthPopupCallbackRoute,
  SettingsRoute: SettingsRoute,
  BlogSlugRoute: BlogSlugRoute,
  EditorProjectIdRoute: EditorProjectIdRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  BlogIndexRoute: BlogIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
